module.exports = __webpack_public_path__ + "media/images/1-9fadaceebfeb7f13cdd55a63fa036eaf.jpg";